import PhotoSwipeLightbox from 'https://cdn.jsdelivr.net/npm/photoswipe@5.4.4/dist/photoswipe-lightbox.esm.min.js';

document.addEventListener('DOMContentLoaded', () => {

  const lightbox = new PhotoSwipeLightbox({
    gallery: '[id^="Slider-Gallery"]',
    children: '.pswp-gallery-item',

    pswpModule: () =>
      import('https://cdn.jsdelivr.net/npm/photoswipe@5.4.4/dist/photoswipe.esm.min.js'),

    initialZoomLevel: 'fit',
    secondaryZoomLevel: 2.5,
    mainClass: 'pswp--custom-bg',
    maxZoomLevel: 6,
    bgOpacity: 0.95,
    wheelToZoom: true,
    showHideAnimationType: 'zoom'
  });

  lightbox.init();

});




 

     

   

